<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        10.19
        <br />2017
      </span>
      <span class="tiel">美菜：互联网+精准扶贫的践行者</span>
    </div>

    <div class="mat-content">
      <div class="title-bold">
        <span></span>践行十九大精准扶贫精神，美菜为农产品上行助力
      </div>
      <div class="tet-js">
        举世瞩目的中国共产党第十九次全国代表大会开幕会于2017年10月18日上午9：00在人民大会堂大礼堂举行。
        <br />
        <br />作为“互联网+农业“创新创业的代表，美菜网创始人兼CEO刘传军在观看学习总书记所作报告后表示，美菜要将党的十九大精神和公司的发展目标结合起来，将布局全国，影响近万个乡镇的农业发展，深入推进农业供给侧结构性改革，坚持精准扶贫，不忘初心，方得始终。
        <br />
        <br />据悉，美菜网于2014年成立，一直是互联网+精准扶贫的践行者，美菜网依托互联网+物流体系，砍掉层层抽利的中间环节，将田间地头一站式对接餐厅，利用大数据，对贫困地区的种植养殖行为提供精准的市场分析，尽最大限度避免出现农产品“扎堆”的境遇。2017年，美菜网农产品上行将超过百亿规模，仅果蔬产品将超过8亿斤。
        <br />
        <br />
      </div>
      <p align="center">
        <img src="@/assets/images/new-img/b5_01.jpg" width="640" />
      </p>
      <div class="tet-js">
        美菜网在积极落实精准扶贫方面成果显著。5月至今，美菜网已经在山东省、安徽省、河北省等地区帮扶采购圆葱、土豆、西瓜、卷心菜等农产品，共计300余万斤。日前，国家级贫困县内蒙古乌兰察布市察哈尔右翼中旗突降大雪，草原红萝卜愁销路，美菜网第一时间赴当地采购，并销往京津两地。扶贫菜帮扶联盟还为江西赣州石城县猪肚菇对接销售渠道，并对来年的种养殖提出意见和建议。
        <br />
        <br />正如总书记在十九大报告中指出的，提高保障和改善民生水平，要优先发展教育事业，高度重视农村义务教育，同时要坚决打赢脱贫攻坚战，坚持精准扶贫，注重扶贫同扶志、扶智相结合。
        <br />
        <br />为此，美菜网针对贫困地区发起“最美菜扶贫公开课”项目，旨在增强贫困地区的自我造血能力，进行智力扶贫。目前，已经在内蒙古地区针对电商青年开启了扶贫公开课的首次试讲，下一步，美菜网最美菜公益基金还将继续关注农村留守儿童、贫困地区农产品上行、智力扶贫等方面，做到精准扶贫，因地制宜。
        <br />
        <br />美菜网创始人CEO刘传军表示，坚持精准扶贫是直接关系人民群众现实利益的问题，作为从农村走出来的青年创业者，他希望，美菜网能以“互联网+农业”的方式，真正将互联网思维引入农业，改变农业的生产组织形式，改变以往农产品的销售方法，为农产品上行助力，真正为8亿农民谋福利。
        <br />
        <br />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>
</style>
